import Vue from 'vue'
import DOMPurify from 'dompurify'

Vue.filter('sanitize', function (value) {
  if (!value) return ''
  return DOMPurify.sanitize(value)
})

Vue.directive('sanitize', {
  bind(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value || '')
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = DOMPurify.sanitize(binding.value || '')
    }
  }
})

export function sanitizeHTML(value) {
  if (!value) return ''
  return DOMPurify.sanitize(value)
}

export default DOMPurify
